module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-bank-anna-lena.09445112.jpg";